$(document).on('click', '.mainBtnToSimulatAdd', function () {

    $('.mainBtnToSimulatAdd').addClass('loading');
    // 1. Clear cart
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
        'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(() => {

        // 2. Trigger your add-to-cart button
        $('.mainBtnAdding').trigger('click');

        // 3. Hide #upCart with !important
        var $upCart = $('#upCart');

        if ($upCart.length) {
        $upCart[0].style.setProperty('display', 'none', 'important');

        setTimeout(function () {
            $upCart[0].style.removeProperty('display');
            $('.mainBtnToSimulatAdd').removeClass('loading');
        }, 3000);
        }

        // 4. Force body overflow
        $('body')[0].style.setProperty('overflow', 'unset', 'important');

        setTimeout(function(){  
            window.location.href = '/checkout';
            
        },1000);
        

    })
    .catch((err) => {
        console.error('Error clearing cart:', err);
    });

});